import { ROLES } from '@/constants/roles';

export const eventTeamRegister = {
  path: '/event/team-register/:id',
  name: 'event-team-register',
  component: () => import('./views/team-register.vue'),
  props: (route) => ({
    id: Number(route.params.id),
  }),
  meta: {
    layout: 'ui-design',
    title: 'Запись на мероприятие',
    accessList: [ROLES.trainer],
  },
};

export default [eventTeamRegister];
